<template>
  <div>
    <el-table
      :data="allAddressData"
      height="320px"
      :v-loading="addressTableLoading"
      empty-text="No items"
    >
      <el-table-column
        property="address"
        :label="$t('WithdrawUSDT.ListAddress')"
      ></el-table-column>
      <el-table-column
        property="tag"
        :label="$t('WithdrawUSDT.ListTag')"
      >
      <template slot-scope="scope">
        <div>
          <span>{{ scope.row.tag }}</span>
          <i @click="showEditorTagDialog(scope.row)" class="el-icon-edit-outline" style="color:#67C23A;margin-left: 5px;cursor:pointer;font-size: 20px;vertical-align:-2px;"></i>
        </div>
      </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <div
            style="
              display: flex;
              gap: 6px;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <el-button
              @click="clickSelected(scope.row)"
              type="success"
              v-if="isUseSelect"
              size="small"
              >{{ $t("WithdrawUSDT.SelectBtn") }}</el-button
            >
            <el-button
              @click="clickDeleted(scope.row)"
              type="danger"
              size="small"
              >{{ $t("WithdrawUSDT.ListDelete") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      custom-class="brd"
      :close-on-click-modal="false"
      :visible.sync="showEditorDialog"
      :title="$t('VirtualCard.Modifylabel')"
      append-to-body
    >
      <div>
        <div style="margin-bottom: 20px">
          <div style="margin-bottom: 8px">
                <sup
                  style="
                    color: red;
                    margin-right: 5px;
                    font-size: 14px;
                    vertical-align: bottom;
                  "
                  >*</sup
                >{{ $t("WithdrawUSDT.ListTag") }}
          </div>
              <CInput
                v-model="editorForm.tag"
                type="text"
                valid-feedback=""
              />
        </div>
      </div>
      <div slot="footer">
        <el-button size="small" @click="cancelEditor">{{ $t("WithdrawUSDT.Cancel") }}</el-button>
        <el-button
            size="small"
            @click="updateTag"
            style="background-color: #00bea4; color: #fff"
            >{{ $t("WithdrawUSDT.Confirm") }}</el-button
          >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updataUSDTAddressTag } from '@/api/http.js'
export default {
    props: {
        allAddressData: {
            type: Array,
        },
        addressTableLoading: {
            type: Boolean
        },
        isUseSelect: {
            type: Boolean
        },
    },
    data() {
        return {
          editorForm: {
            tag: '',
            address: ''
          },
          showEditorDialog: false
        }
    },
    methods: {
        clickSelected(item) {
            this.$emit('emitSelected', item)
        },
        clickDeleted(item) {
            this.$emit('emitDeleted', item)
        },
        // 显示更新窗口
        showEditorTagDialog(item) {
          this.editorForm.tag = item.tag
          this.editorForm.address = item.address
          this.showEditorDialog = true
          // this.$emit('emitInitListData')
        },
        // 取消更新
        cancelEditor() {
          this.showEditorDialog = false
          this.editorForm.tag = ''
          this.editorForm.address = ''
        },
        // 更新标签
        updateTag() {
          if(this.editorForm.tag == '') {
            return;
          }
          const data = {
            type: 'update_withdraw_address_tag',
            uid: localStorage.getItem("uid"),
            address: this.editorForm.address,
            tag: this.editorForm.tag
          }
          updataUSDTAddressTag(data).then((res) => {
            if(res.code == 200) {
              this.showEditorDialog = false
              this.cancelEditor()
              // 更新列表数据
              this.$emit('emitInitListData')
            } else {
              this.$message.error(res.message)
            }
          })
        }
    }
}
</script>